import { Box, Link } from '@flos/react-ui';
import ProductAndPriceList from './ProductAndPriceList';
import CustomerBenefit from '../../../shared_components/CustomerBenefit/CustomerBenefit';
import TotalPrice from '../../../shared_components/TotalPrice/TotalPrice';
import { useRecoilState, useRecoilValue } from 'recoil';
import { QUOTED } from '../../../recoil/types/types';
import { jobAtom } from '../../../recoil/atoms/jobAtom';
import { paymentFrequencyMap, periodicityUnit } from '../../../utils/currencyUtil';
import ShoppingBasketGovernmentFee from '../../ShoppingBasketPage/components/ShoppingBasketGovernmentFee';
import { priceTaxAtom } from '../../../recoil/atoms/priceTaxAtom';
import { useRemoveApprovedTimestampAndReminderHook } from '../../../hooks/useRemoveApprovedTimestampAndReminderHook';
import { useHippoText } from '../../../hooks/useHippoText';
import useWizardNavigation from '../../../hooks/useWizardNavigation';
import { filterGovernmentFees } from '../../ShoppingBasketPage/utils/ShoppingBasketUtil';

const CheckoutSidebar = (): React.JSX.Element => {
    const [jobData, setJobData] = useRecoilState(jobAtom);
    const selectedPaymentFrequency =
        jobData.selectedPaymentFrequency ?? paymentFrequencyMap.monthly;
    const isPaymentYearly = selectedPaymentFrequency === paymentFrequencyMap.annual;

    const priceTaxData = useRecoilValue(priceTaxAtom);
    const governmentFees =
        selectedPaymentFrequency === 'onetime' ? [] : priceTaxData.annualTaxes ?? [];
    const filteredGovernmentFees = filterGovernmentFees(governmentFees);

    const { removeApprovedTimestampAndReminder } = useRemoveApprovedTimestampAndReminderHook();
    const { wizardGotoStep } = useWizardNavigation();
    const getHippoText = useHippoText();

    const goBackToShoppingBasket = (): void => {
        void removeApprovedTimestampAndReminder().then(() => {
            setJobData({ ...jobData, jobStatus: QUOTED });
            wizardGotoStep('ShoppingBasketPage');
        });
    };

    const hippoTexts = {
        shoppingBasketHeader: getHippoText('DSS-COMMON-SHOPPING-BASKET-HEADER'),
        editShoppingBasketButton: getHippoText('DSS-CHECKOUT-EDIT-BASKET')
    };

    return (
        <div className={'u-flex-box u-flex-box--col'}>
            <Box padding={'large'} theme={'transparent'} className={'u-shadow-none'}>
                <div className={'u-flex-box u-flex-box--space-between'}>
                    <p className={'paragraph--small u-color-secondary-4-medium'}>
                        {hippoTexts.shoppingBasketHeader}
                    </p>
                    <Link
                        className="paragraph--small"
                        onClick={goBackToShoppingBasket}
                        theme={'logo'}
                    >
                        {hippoTexts.editShoppingBasketButton}
                    </Link>
                </div>
                <hr className={'u-spacing-stack-none'} />
                <ProductAndPriceList
                    paymentFrequency={selectedPaymentFrequency}
                    isPaymentYearly={isPaymentYearly}
                />
                <hr className={'u-spacing-stack-m'} />
                <CustomerBenefit interactive={false} />
                <hr className={'u-spacing-stack-l'} />
                <TotalPrice
                    totalPrice={
                        selectedPaymentFrequency === paymentFrequencyMap.monthly
                            ? priceTaxData.monthlyPrice?.amount ?? 0
                            : priceTaxData.yearlyPrice?.amount ?? 0
                    }
                    showYearlyPriceField={selectedPaymentFrequency === paymentFrequencyMap.monthly}
                    paymentFrequencyPostfix={periodicityUnit[selectedPaymentFrequency]}
                />
            </Box>
            {!!filteredGovernmentFees.length && (
                <Box padding={'large'} theme={'transparent'} className={'u-shadow-none'}>
                    <ShoppingBasketGovernmentFee
                        isPaymentYearly={isPaymentYearly}
                        governmentFees={filteredGovernmentFees}
                    />
                </Box>
            )}
        </div>
    );
};

export default CheckoutSidebar;
